































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Mutations, Views, ViewModes } from '@/ts/store/Constants';
import OptionsData from '@/ts/OptionsData';
import HococoImageSlider from '@/components/HococoImageSlider.vue';

@Component({
   components: {
       HococoImageSlider,
   },
})
export default class MobileSingleOption extends Vue {
    @Prop() public item!: OptionsData;

    constructor() {
        super();
    }

    public imageCollection() {
        const images: string[] = [
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAH0lEQVR42mP8/5/hPwMVAeOogaMGjho4auCogSPVQABXljvZ3Sl18AAAAABJRU5ErkJggg==',
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAH0lEQVR42mPkZKj6z0BFwDhq4KiBowaOGjhq4Eg1EAARih49qX9b+AAAAABJRU5ErkJggg==',
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAH0lEQVR42mOs4rT9z0BFwDhq4KiBowaOGjhq4Eg1EADrpSMBbzImaQAAAABJRU5ErkJggg==',
        ];

        return images;
    }

    public goBack() {
        this.$store.commit(Mutations.UPDATE_ACTIVE_OPTION, null);
        this.$store.commit(Mutations.SET_VIEW, {
            view: Views.Options,
            viewMode: ViewModes.Options.All,
        });
    }

    public selectItem(firstParameter: any) {
        this.$store.commit(Mutations.SELECT_ITEM, firstParameter);
    }
}
